import "../../styles/AdminDashboard/SideBar.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../images/closecarbon_logo_1-removebg-preview 1.png";
import { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const SideBar = () => {
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElTwo, setAnchorElTwo] = useState(null);
  const [anchorElThree, setAnchorElThree] = useState(null)
  const [anchorElFour, setAnchorElFour] = useState(null);
  const opener = Boolean(anchorEl);
  const openerTwo = Boolean(anchorElTwo);
  const openerThree = Boolean(anchorElThree);
  const openerFour = Boolean(anchorElFour);

  const { pathname } = useLocation();


    // 🔒 Permission Logic
  // const userPermissions = Array.isArray(auth?.userInfo?.role)
  //   ? auth.userInfo.role
  //   : [auth?.userInfo?.role]; // fallback if it's a string

  // const hasPermission = (perm) => userPermissions.includes(perm);


  const handleLogout = () => {
    dispatch({
      type: "LOGOUT_SUCCESS",
    });
    localStorage.removeItem("token");
    navigate("/admin/login");
    window.scrollTo(0, 0);
  };

  const handeMobileMenuClose = () => {
    dispatch({
      type: "SET_MENU_VISIBLE",
      payload: false,
    });
  };

  useEffect(() => {
    handeMobileMenuClose();
  }, [pathname]);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseTwo = () => {
    setAnchorElTwo(null);
  };
  const handleCloseThree = () => {
    setAnchorElThree(null);
  };
  const handleCloseFour = () => {
    setAnchorElFour(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickTwo = (event) => {
    setAnchorElTwo(event.currentTarget);
  };
  const handleClickThree = (event) => {
    setAnchorElThree(event.currentTarget);
  };
  const handleClickFour = (event) => {
    setAnchorElFour(event.currentTarget);
  };
  const allowedEmails = ["cc.admin@netzence.com.ng", "favourdabit+234@gmail.com"];



const Dashboard = ["Dashboard"]
  return (
    <div className="admin_sidebar">
      <div className="logo_container">
        <div>
          <img
            src={Logo}
            alt=""
            className=""
            onClick={() => navigate("/admin/dashboard")}
          />
        </div>
      </div>
      <svg
        className="sidebar__ipad-pro"
        onClick={handeMobileMenuClose}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8999 1.50004C15.2999 1.65004 17.5499 2.85004 19.1999 4.50004C21.1499 6.60004 22.1999 9.15004 22.1999 12.15C22.1999 14.55 21.2999 16.8 19.7999 18.75C18.2999 20.55 16.1999 21.9 13.7999 22.35C11.3999 22.8 8.99994 22.5 6.89994 21.3C4.79994 20.1 3.14994 18.3 2.24994 16.05C1.34994 13.8 1.19994 11.25 1.94994 9.00004C2.69994 6.60004 4.04994 4.65004 6.14994 3.30004C8.09994 1.95004 10.4999 1.35004 12.8999 1.50004ZM13.6499 20.85C15.5999 20.4 17.3999 19.35 18.7499 17.7C19.9499 16.05 20.6999 14.1 20.5499 12C20.5499 9.60004 19.6499 7.20004 17.9999 5.55004C16.4999 4.05004 14.6999 3.15004 12.5999 3.00004C10.6499 2.85004 8.54994 3.30004 6.89994 4.50004C5.24994 5.70004 4.04994 7.35004 3.44994 9.45004C2.84994 11.4 2.84994 13.5 3.74994 15.45C4.64994 17.4 5.99994 18.9 7.79994 19.95C9.59994 21 11.6999 21.3 13.6499 20.85ZM11.8499 11.25L15.4499 7.50004L16.4999 8.55004L12.8999 12.3L16.4999 16.05L15.4499 17.1L11.8499 13.35L8.24994 17.1L7.19994 16.05L10.7999 12.3L7.19994 8.55004L8.24994 7.50004L11.8499 11.25Z"
          fill="#667185"
        />
      </svg>
      <div className="menu">
        {/* {(hasPermission("superAdmin") ||hasPermission("admin")) &&  */}
        
       {/* (  */}
        <div
          className={
            pathname.includes("dashboard")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() => {
            navigate("/admin/dashboard");
            window.scrollTo(0, 0);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.459 1.66059C12.3259 1.55684 12.162 1.50049 11.9932 1.50049C11.8245 1.50049 11.6606 1.55684 11.5275 1.66059L0.75 10.0643L1.68225 11.2433L3 10.2158V19.5001C3.00079 19.8977 3.15908 20.2787 3.44022 20.5599C3.72135 20.841 4.10242 20.9993 4.5 21.0001H19.5C19.8976 20.9993 20.2787 20.841 20.5598 20.5599C20.8409 20.2787 20.9992 19.8977 21 19.5001V10.2226L22.3177 11.2501L23.25 10.0711L12.459 1.66059ZM13.5 19.5001H10.5V13.5001H13.5V19.5001ZM15 19.5001V13.5001C14.9996 13.1024 14.8414 12.7211 14.5602 12.4399C14.279 12.1587 13.8977 12.0005 13.5 12.0001H10.5C10.1023 12.0005 9.721 12.1587 9.43978 12.4399C9.15856 12.7211 9.0004 13.1024 9 13.5001V19.5001H4.5V9.04659L12 3.20409L19.5 9.05409V19.5001H15Z"
              fill="#667185"
            />
          </svg>

          <div>Dashboards </div>
        </div>
        {/* )} */}
   

        {/* { (hasPermission("superAdmin")) &&  */}
        <div
          className={
            pathname.includes("carbon-credit" || "business-and-businessPlus-carbon-credit")
              ? "menu_item menu_active"
              : "menu_item"
          }
          // onClick={() => {
          //   navigate("/admin/website/settings");
          //   window.scrollTo(0, 0);
          // }}
          onClick={handleClickFour}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.1318 13.2669L17.6318 10.6044C17.5162 10.5359 17.3843 10.4999 17.2499 10.5C17.1155 10.5001 16.9837 10.5365 16.8682 10.6052L12.3682 13.2677C12.2561 13.3338 12.1631 13.4281 12.0985 13.5413C12.0339 13.6544 12 13.7824 12 13.9127V19.0877C12 19.3532 12.1402 19.5984 12.3682 19.7327L16.8682 22.3952C16.9836 22.4644 17.1155 22.5009 17.25 22.5009C17.3845 22.5009 17.5164 22.4644 17.6318 22.3952L22.1318 19.7327C22.2439 19.6665 22.3369 19.5722 22.4015 19.4591C22.4661 19.3459 22.5 19.2179 22.5 19.0877V13.9127C22.5 13.7823 22.4661 13.6542 22.4015 13.541C22.3369 13.4277 22.244 13.3333 22.1318 13.2669ZM21 18.6602L17.25 20.8787L13.5 18.6602V14.3402L17.25 12.1217L21 14.3402V18.6602Z" fill="#667185" />
            <path d="M4.5 5.25C4.91421 5.25 5.25 4.91421 5.25 4.5C5.25 4.08579 4.91421 3.75 4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5C3.75 4.91421 4.08579 5.25 4.5 5.25Z" fill="#667185" />
            <path d="M6.75 5.25C7.16421 5.25 7.5 4.91421 7.5 4.5C7.5 4.08579 7.16421 3.75 6.75 3.75C6.33579 3.75 6 4.08579 6 4.5C6 4.91421 6.33579 5.25 6.75 5.25Z" fill="#667185" />
            <path d="M21 1.5H3C2.17275 1.5 1.5 2.17275 1.5 3V18C1.5 18.8272 2.17275 19.5 3 19.5H9.75V18H3V7.5H21V10.5H22.5V3C22.5 2.17275 21.8272 1.5 21 1.5ZM3 6V3H21V6H3Z" fill="#667185" />
          </svg>
          <div>
            CCRT{" "}
            <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L6 6L11 1"
                stroke="#D0D5DD"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>


          {/* <div className="menu_item__dropdown">
            <div>Account</div>
            <div>Password</div>
            <div>Account manager</div>
          </div> */}
        </div>
        {/* } */}
        {/* {(hasPermission("superAdmin")) &&  */}

        <Menu
          id="basic-menu"
          anchorEl={anchorElFour}
          open={openerFour}
          onClose={handleCloseFour}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            sx={{
              width: "18.4rem",
              fontSize: "1.4rem",
              fontFamily: "Inter",
              fontWeight: "500",
              backgroundColor: "#fff !important",

                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/carbon-credit");
                window.scrollTo(0, 0);
                handleCloseFour();
              }}
            >
              CCRT Issuance
            </MenuItem>
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",

              "&:hover": {
                color: "#063",
                backgroundColor: "#fff",
              },
            }}
            className="subMenu"
            onClick={() => {
              navigate("/admin/liquidity-pool");
              window.scrollTo(0, 0);
              handleCloseFour();
            }}
          >
            CCRT Exchange
          </MenuItem>
        </Menu>
{/* } */}
      {/* { (hasPermission("validator")|| hasPermission("superAdmin")) && */}
        <div
          className={
            pathname.includes("validation") ? "menu_item menu_active" : "menu_item"
          }
          onClick={() => {
            navigate("/admin/validation");
            window.scrollTo(0, 0);
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.1318 13.2669L17.6318 10.6044C17.5162 10.5359 17.3843 10.4999 17.2499 10.5C17.1155 10.5001 16.9837 10.5365 16.8682 10.6052L12.3682 13.2677C12.2561 13.3338 12.1631 13.4281 12.0985 13.5413C12.0339 13.6544 12 13.7824 12 13.9127V19.0877C12 19.3532 12.1402 19.5984 12.3682 19.7327L16.8682 22.3952C16.9836 22.4644 17.1155 22.5009 17.25 22.5009C17.3845 22.5009 17.5164 22.4644 17.6318 22.3952L22.1318 19.7327C22.2439 19.6665 22.3369 19.5722 22.4015 19.4591C22.4661 19.3459 22.5 19.2179 22.5 19.0877V13.9127C22.5 13.7823 22.4661 13.6542 22.4015 13.541C22.3369 13.4277 22.244 13.3333 22.1318 13.2669ZM21 18.6602L17.25 20.8787L13.5 18.6602V14.3402L17.25 12.1217L21 14.3402V18.6602Z" fill="#667185" />
            <path d="M4.5 5.25C4.91421 5.25 5.25 4.91421 5.25 4.5C5.25 4.08579 4.91421 3.75 4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5C3.75 4.91421 4.08579 5.25 4.5 5.25Z" fill="#667185" />
            <path d="M6.75 5.25C7.16421 5.25 7.5 4.91421 7.5 4.5C7.5 4.08579 7.16421 3.75 6.75 3.75C6.33579 3.75 6 4.08579 6 4.5C6 4.91421 6.33579 5.25 6.75 5.25Z" fill="#667185" />
            <path d="M21 1.5H3C2.17275 1.5 1.5 2.17275 1.5 3V18C1.5 18.8272 2.17275 19.5 3 19.5H9.75V18H3V7.5H21V10.5H22.5V3C22.5 2.17275 21.8272 1.5 21 1.5ZM3 6V3H21V6H3Z" fill="#667185" />
          </svg>

          <div> KYC Validation</div>
        </div>
{/* } */}
        {/* {(hasPermission("superAdmin"||"RO"||"admin"))  && */}
         <div
          className={
            pathname.includes("users") ? "menu_item menu_active" : "menu_item"
          }
          onClick={() => {
            navigate("/admin/users");
            window.scrollTo(0, 0);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9921 14.8051C11.9973 14.1359 12.7605 13.161 13.1687 12.0245C13.577 10.888 13.6087 9.65036 13.2591 8.49449C12.9095 7.33862 12.1973 6.32593 11.2276 5.60617C10.258 4.88642 9.0825 4.4978 7.87492 4.4978C6.66735 4.4978 5.49184 4.88642 4.52221 5.60617C3.55258 6.32593 2.84032 7.33862 2.49076 8.49449C2.1412 9.65036 2.17288 10.888 2.58114 12.0245C2.9894 13.161 3.75255 14.1359 4.75774 14.8051C2.93945 15.4752 1.38659 16.7154 0.330862 18.3404C0.275377 18.4229 0.236837 18.5155 0.217482 18.613C0.198127 18.7105 0.198344 18.8109 0.218119 18.9083C0.237895 19.0057 0.276835 19.0982 0.332676 19.1804C0.388516 19.2627 0.460144 19.333 0.543396 19.3873C0.626647 19.4416 0.719861 19.4788 0.81762 19.4967C0.915378 19.5147 1.01573 19.513 1.11285 19.4919C1.20996 19.4707 1.3019 19.4304 1.38332 19.3734C1.46473 19.3164 1.53401 19.2438 1.58711 19.1598C2.2681 18.1124 3.19995 17.2517 4.29802 16.6559C5.3961 16.0601 6.62562 15.748 7.87492 15.748C9.12423 15.748 10.3538 16.0601 11.4518 16.6559C12.5499 17.2517 13.4817 18.1124 14.1627 19.1598C14.2727 19.3233 14.4427 19.4369 14.6358 19.4761C14.8289 19.5153 15.0297 19.4769 15.1947 19.3693C15.3598 19.2616 15.4758 19.0934 15.5178 18.9008C15.5598 18.7083 15.5243 18.507 15.419 18.3404C14.3633 16.7154 12.8104 15.4752 10.9921 14.8051ZM3.74992 10.1251C3.74992 9.30924 3.99185 8.51171 4.44511 7.83336C4.89837 7.155 5.54261 6.62629 6.29636 6.31408C7.0501 6.00187 7.8795 5.92018 8.67967 6.07935C9.47984 6.23851 10.2148 6.63138 10.7917 7.20827C11.3686 7.78516 11.7615 8.52017 11.9207 9.32034C12.0798 10.1205 11.9981 10.9499 11.6859 11.7037C11.3737 12.4574 10.845 13.1016 10.1667 13.5549C9.4883 14.0082 8.69077 14.2501 7.87492 14.2501C6.78129 14.2488 5.7328 13.8138 4.95948 13.0405C4.18616 12.2672 3.75117 11.2187 3.74992 10.1251ZM23.4506 19.3782C23.284 19.4868 23.081 19.5249 22.8864 19.4839C22.6918 19.4429 22.5214 19.3263 22.4127 19.1598C21.7326 18.1118 20.8008 17.2507 19.7025 16.6551C18.6042 16.0596 17.3743 15.7484 16.1249 15.7501C15.926 15.7501 15.7352 15.6711 15.5946 15.5304C15.4539 15.3898 15.3749 15.199 15.3749 15.0001C15.3749 14.8012 15.4539 14.6104 15.5946 14.4698C15.7352 14.3291 15.926 14.2501 16.1249 14.2501C16.7324 14.2495 17.3322 14.1148 17.8816 13.8555C18.431 13.5962 18.9163 13.2188 19.3029 12.7502C19.6895 12.2817 19.9678 11.7335 20.118 11.1449C20.2682 10.5563 20.2865 9.94174 20.1716 9.34522C20.0568 8.74871 19.8116 8.18492 19.4536 7.69414C19.0956 7.20337 18.6337 6.79772 18.1007 6.50618C17.5678 6.21464 16.977 6.04441 16.3707 6.00765C15.7643 5.97089 15.1573 6.0685 14.5931 6.29352C14.501 6.33329 14.402 6.35422 14.3018 6.35507C14.2016 6.35591 14.1022 6.33666 14.0095 6.29845C13.9169 6.26024 13.8328 6.20385 13.7623 6.1326C13.6918 6.06135 13.6363 5.9767 13.5991 5.88364C13.5619 5.79058 13.5437 5.691 13.5456 5.59079C13.5475 5.49058 13.5695 5.39177 13.6102 5.3002C13.651 5.20862 13.7097 5.12615 13.7828 5.05764C13.856 4.98913 13.9421 4.93598 14.0362 4.90134C15.3275 4.38632 16.7639 4.36779 18.0681 4.84931C19.3723 5.33083 20.452 6.27829 21.0989 7.50891C21.7458 8.73953 21.914 10.1661 21.5711 11.5134C21.2283 12.8608 20.3986 14.0334 19.2421 14.8051C21.0604 15.4752 22.6133 16.7154 23.669 18.3404C23.7776 18.507 23.8156 18.7099 23.7747 18.9045C23.7337 19.0992 23.6171 19.2695 23.4506 19.3782Z"
              fill="#667185"
            />
          </svg>

          <div>Users</div>
        </div>
        {/* } */}
        {/* {(hasPermission("admin" ) || hasPermission("superAdmin")) &&  */}
        <div
          className={
            pathname.includes("validators")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() => navigate("/admin/validators")}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 21H22.5V22.5H18V21Z" fill="#667185" />
            <path d="M15.75 22.5C16.1642 22.5 16.5 22.1642 16.5 21.75C16.5 21.3358 16.1642 21 15.75 21C15.3358 21 15 21.3358 15 21.75C15 22.1642 15.3358 22.5 15.75 22.5Z" fill="#667185" />
            <path d="M21.75 19.5C22.1642 19.5 22.5 19.1642 22.5 18.75C22.5 18.3358 22.1642 18 21.75 18C21.3358 18 21 18.3358 21 18.75C21 19.1642 21.3358 19.5 21.75 19.5Z" fill="#667185" />
            <path d="M19.5 19.5H15V18H19.5V19.5ZM18 15H22.5V16.5H18V15Z" fill="#667185" />
            <path d="M15.75 16.5C16.1642 16.5 16.5 16.1642 16.5 15.75C16.5 15.3358 16.1642 15 15.75 15C15.3358 15 15 15.3358 15 15.75C15 16.1642 15.3358 16.5 15.75 16.5Z" fill="#667185" />
            <path d="M16.1198 10.5974L9.74475 6.98615C9.63199 6.92226 9.5046 6.88867 9.375 6.88867C9.2454 6.88867 9.11801 6.92226 9.00525 6.98615L2.63025 10.5974C2.51482 10.6628 2.41881 10.7577 2.352 10.8723C2.2852 10.9869 2.25 11.1172 2.25 11.2499V18.7499C2.25 18.8826 2.2852 19.0129 2.352 19.1275C2.41881 19.2421 2.51482 19.337 2.63025 19.4024L9.00525 23.0136L9.74475 21.7087L3.75 18.3126V11.6872L9.375 8.50115L15 11.6872V13.4999H16.5V11.2499C16.5 11.1172 16.4648 10.9869 16.398 10.8723C16.3312 10.7577 16.2352 10.6628 16.1198 10.5974Z" fill="#667185" />
            <path d="M18.7487 11.2499H20.2487V5.2499C20.2487 5.11723 20.2135 4.98693 20.1467 4.8723C20.0799 4.75767 19.9838 4.66281 19.8684 4.5974L13.4934 0.98615C13.3806 0.922256 13.2533 0.888672 13.1237 0.888672C12.9941 0.888672 12.8667 0.922256 12.7539 0.98615L6.37891 4.5974L7.11841 5.9024L13.1237 2.5004L18.7487 5.68715V11.2499Z" fill="#667185" />
          </svg>


          <div>Verifiers</div>
        </div>
        {/* } */}
        {/* { (hasPermission("admin") || hasPermission("superAdmin")) &&  */}
        <div
          className={
            pathname.includes("donation")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() => navigate("/admin/donation")}
        >
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2.75C7.8645 2.75 4.5 6.1145 4.5 10.25C4.5 14.3855 7.8645 17.75 12 17.75C16.1355 17.75 19.5 14.3855 19.5 10.25C19.5 6.1145 16.1355 2.75 12 2.75ZM12 4.25C15.3082 4.25 18 6.94175 18 10.25C18 13.5582 15.3082 16.25 12 16.25C8.69175 16.25 6 13.5582 6 10.25C6 6.94175 8.69175 4.25 12 4.25ZM11.25 5.75V6.6425C10.7092 6.83912 10.2614 7.23073 9.9945 7.7405C9.76203 8.1893 9.69207 8.70472 9.7965 9.19925C9.88879 9.6295 10.1028 10.0242 10.413 10.3362C10.6178 10.541 10.8615 10.7067 11.13 10.8215C11.3985 10.9362 11.6925 11 12 11C12.1065 11 12.207 11.0203 12.297 11.057C12.3861 11.0932 12.467 11.147 12.535 11.215C12.603 11.283 12.6568 11.3639 12.693 11.453C12.7297 11.543 12.75 11.6435 12.75 11.75C12.7533 11.8977 12.7117 12.043 12.6309 12.1667C12.55 12.2904 12.4336 12.3867 12.297 12.443C12.207 12.4797 12.1065 12.5 12 12.5C11.8927 12.5 11.793 12.4797 11.703 12.443C11.614 12.4066 11.5332 12.3528 11.4653 12.2847C11.3957 12.2143 11.3409 12.1308 11.304 12.039C11.267 11.9472 11.2487 11.8489 11.25 11.75H9.75C9.75009 12.3335 9.98117 12.8933 10.3927 13.307C10.6336 13.5526 10.9266 13.741 11.25 13.8583V14.75H12.75V13.8575C13.1282 13.7219 13.4635 13.4884 13.7218 13.1807C13.9801 12.873 14.152 12.5022 14.22 12.1063C14.3126 11.5438 14.1842 10.9674 13.8615 10.4975C13.6987 10.2579 13.4921 10.0513 13.2525 9.8885C13.0096 9.7237 12.7371 9.60755 12.45 9.5465C12.302 9.51561 12.1512 9.50003 12 9.5C11.8927 9.5 11.793 9.47975 11.703 9.443C11.6139 9.40675 11.533 9.35304 11.465 9.28503C11.397 9.21702 11.3432 9.13609 11.307 9.047C11.2689 8.95264 11.2495 8.85176 11.25 8.75C11.25 8.64275 11.2703 8.543 11.307 8.453C11.3432 8.36391 11.397 8.28298 11.465 8.21497C11.533 8.14696 11.6139 8.09325 11.703 8.057C11.793 8.02025 11.8935 8 12 8C12.4275 8 12.75 8.3225 12.75 8.75H14.25C14.2502 8.51456 14.2127 8.2806 14.139 8.057C14.0286 7.73203 13.8464 7.43611 13.6059 7.19123C13.3655 6.94635 13.0729 6.75879 12.75 6.6425V5.75H11.25ZM1.5 16.25V22.25H3V17.75H7.035C6.39904 17.3248 5.81944 16.8208 5.31 16.25H1.5ZM18.69 16.25C18.1806 16.8208 17.601 17.3248 16.965 17.75H21V22.25H22.5V16.25H18.69ZM4.5 19.25V20.75H19.5V19.25H4.5Z" fill="#667185" />
          </svg>



          <div>Voluntary donation pool</div>
        </div>
        {/* } */}

        {/* {(hasPermission("admin") || hasPermission("superAdmin")|| hasPermission("RO")) &&  */}
        <div
          className={
            pathname.includes("health-status") ||
              pathname.includes("iot-scheduling")
              ? "menu_item active_iot"
              : "menu_item"
          }
          // onClick={() => {
          //   navigate("/admin/website/settings");
          //   window.scrollTo(0, 0);
          // }}
          onClick={handleClickTwo}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2955 9.01453C11.68 8.95374 11.0607 9.08469 10.5225 9.38945C9.98426 9.69421 9.55339 10.1579 9.28886 10.717C9.02434 11.2761 8.93909 11.9033 9.04479 12.5127C9.1505 13.1221 9.44198 13.684 9.87934 14.1213C10.3167 14.5587 10.8786 14.8502 11.488 14.9559C12.0974 15.0616 12.7246 14.9763 13.2837 14.7118C13.8428 14.4473 14.3065 14.0164 14.6112 13.4782C14.916 12.94 15.0469 12.3207 14.9861 11.7052C14.9168 11.0151 14.6111 10.3703 14.1207 9.87995C13.6304 9.38958 12.9855 9.08384 12.2955 9.01453ZM19.5189 12C19.517 12.3261 19.4931 12.6517 19.4472 12.9745L21.5664 14.6367C21.6587 14.7132 21.7209 14.8199 21.7419 14.9379C21.763 15.056 21.7415 15.1776 21.6813 15.2812L19.6764 18.75C19.6156 18.8527 19.5204 18.9305 19.4077 18.9699C19.295 19.0093 19.1721 19.0076 19.0605 18.9652L16.9558 18.1177C16.8398 18.0714 16.714 18.0547 16.5899 18.0691C16.4658 18.0834 16.3472 18.1283 16.2447 18.1997C15.9235 18.4209 15.586 18.6174 15.235 18.7875C15.1247 18.8411 15.0293 18.9211 14.9572 19.0203C14.8851 19.1196 14.8385 19.2351 14.8216 19.3566L14.5061 21.6014C14.4854 21.72 14.4242 21.8276 14.3329 21.906C14.2415 21.9844 14.1258 22.0287 14.0055 22.0312H9.99582C9.87748 22.0292 9.76337 21.9869 9.67228 21.9113C9.5812 21.8357 9.51857 21.7314 9.49473 21.6155L9.17973 19.3739C9.16204 19.2511 9.11427 19.1345 9.04067 19.0346C8.96707 18.9346 8.86992 18.8544 8.75785 18.8011C8.40733 18.6319 8.07094 18.4349 7.75192 18.2119C7.64977 18.1408 7.53155 18.0963 7.40791 18.0823C7.28426 18.0683 7.15908 18.0853 7.04364 18.1317L4.93942 18.9788C4.82791 19.0212 4.70499 19.023 4.59231 18.9837C4.47964 18.9444 4.38444 18.8666 4.32348 18.7641L2.31864 15.2953C2.25836 15.1917 2.23682 15.07 2.25785 14.952C2.27888 14.834 2.34112 14.7272 2.43348 14.6508L4.22457 13.2445C4.3227 13.1666 4.39982 13.0655 4.44893 12.9502C4.49805 12.835 4.5176 12.7093 4.50582 12.5845C4.48895 12.3891 4.47864 12.1941 4.47864 11.9986C4.47864 11.8031 4.48848 11.6109 4.50582 11.4197C4.51632 11.2957 4.4958 11.1711 4.44613 11.057C4.39646 10.9429 4.3192 10.843 4.22129 10.7662L2.43114 9.36C2.34027 9.28317 2.27935 9.17681 2.25904 9.05957C2.23872 8.94232 2.26032 8.82167 2.32004 8.71875L4.32489 5.25C4.38577 5.14734 4.48094 5.06946 4.59362 5.0301C4.7063 4.99074 4.82926 4.99242 4.94082 5.03484L7.04551 5.88234C7.16157 5.92856 7.28729 5.94525 7.41139 5.93094C7.5355 5.91662 7.65411 5.87174 7.7566 5.80031C8.07782 5.57912 8.41535 5.38262 8.76629 5.2125C8.87662 5.15887 8.97206 5.07891 9.04416 4.97966C9.11627 4.88042 9.16283 4.76494 9.17973 4.64344L9.4952 2.39859C9.51592 2.28004 9.57717 2.17236 9.66848 2.09396C9.75979 2.01555 9.8755 1.9713 9.99582 1.96875H14.0055C14.1238 1.9708 14.238 2.01309 14.329 2.08867C14.4201 2.16425 14.4828 2.2686 14.5066 2.38453L14.8216 4.62609C14.8393 4.74894 14.8871 4.86551 14.9607 4.96544C15.0343 5.06537 15.1314 5.14557 15.2435 5.19891C15.594 5.3681 15.9304 5.56514 16.2494 5.78813C16.3516 5.85919 16.4698 5.90373 16.5934 5.91772C16.7171 5.93172 16.8423 5.91473 16.9577 5.86828L19.0619 5.02125C19.1734 4.97879 19.2963 4.97704 19.409 5.01631C19.5217 5.05558 19.6169 5.13336 19.6779 5.23594L21.6827 8.70469C21.743 8.80832 21.7645 8.92999 21.7435 9.04802C21.7225 9.16604 21.6602 9.27278 21.5679 9.34922L19.7768 10.7555C19.6782 10.8331 19.6006 10.9342 19.5511 11.0494C19.5016 11.1647 19.4817 11.2905 19.4932 11.4155C19.5086 11.6095 19.5189 11.8045 19.5189 12Z"
              fill="#667185"
            />
          </svg>

          <div>
            IoT Devices{" "}
            <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L6 6L11 1"
                stroke="#D0D5DD"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* <div className="menu_item__dropdown">
            <div>Account</div>
            <div>Password</div>
            <div>Account manager</div>
          </div> */}
        </div>
        {/* } */}
        {/* {(hasPermission("admin")|| hasPermission( "superAdmin") ||hasPermission("RO")) &&  */}
        <Menu
          id="basic-menu"
          anchorEl={anchorElTwo}
          open={openerTwo}
          onClose={handleCloseTwo}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            sx={{
              width: "18.4rem",
              fontSize: "1.4rem",
              fontFamily: "Inter",
              fontWeight: "500",
              backgroundColor: "#fff !important",

                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/iot-scheduling");
                window.scrollTo(0, 0);
                handleCloseTwo();
              }}
            >
              Scheduling
            </MenuItem>
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",

                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/health-status");
                window.scrollTo(0, 0);
                handleCloseTwo();
              }}
            >
              Health
            </MenuItem>
          </Menu>
          {/* } */}

        {/* {(hasPermission("superAdmin")|| hasPermission("admin")) && */}
         <div
          className={
            pathname.includes("ndc")
              ? "menu_item active_iot"
              : "menu_item"
          }
          // onClick={() => {
          //   navigate("/admin/website/settings");
          //   window.scrollTo(0, 0);
          // }}
          onClick={handleClickThree}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 17.25L10.3958 16.4902C9.75499 16.1848 9.21359 15.7045 8.83395 15.1047C8.4543 14.5049 8.25188 13.8101 8.25 13.1002V8.25H15.75V13.101C15.7482 13.8109 15.5458 14.5057 15.1662 15.1055C14.7865 15.7053 14.2451 16.1856 13.6042 16.491L12 17.25ZM9.75 9.75V13.101C9.75115 13.5267 9.87267 13.9435 10.1005 14.3031C10.3284 14.6627 10.6533 14.9506 11.0378 15.1335L12 15.5895L12.9623 15.1343C13.3467 14.9512 13.6716 14.6631 13.8994 14.3034C14.1273 13.9437 14.2488 13.5268 14.25 13.101V9.75H9.75ZM3.09 13.242C3.30444 13.0971 3.47773 12.8991 3.59301 12.6673C3.70829 12.4356 3.76164 12.1779 3.74788 11.9195C3.73411 11.661 3.65369 11.4105 3.51445 11.1923C3.3752 10.9741 3.18186 10.7957 2.95324 10.6743C2.72461 10.553 2.46847 10.4929 2.20973 10.4998C1.95098 10.5068 1.69844 10.5805 1.47666 10.714C1.25487 10.8474 1.07139 11.036 0.944058 11.2613C0.816726 11.4867 0.749873 11.7412 0.75 12C0.75 12.5918 1.095 13.098 1.593 13.3425C1.84171 15.3181 2.64916 17.1816 3.92047 18.7141C5.19177 20.2466 6.8741 21.3844 8.76975 21.9938L9.23025 20.5658C7.62038 20.0482 6.18968 19.086 5.10333 17.7901C4.01698 16.4942 3.31852 14.9175 3.09 13.242ZM21.9945 15.231L20.5665 14.769C20.0491 16.379 19.0869 17.8099 17.791 18.8964C16.4951 19.9828 14.9183 20.6807 13.2428 20.9093C13.0977 20.695 12.8997 20.5218 12.668 20.4067C12.4363 20.2916 12.1787 20.2383 11.9204 20.2521C11.662 20.266 11.4116 20.3464 11.1935 20.4856C10.9754 20.6248 10.797 20.8181 10.6757 21.0466C10.5543 21.2751 10.4942 21.5312 10.501 21.7898C10.5079 22.0485 10.5816 22.301 10.7149 22.5227C10.8482 22.7445 11.0366 22.928 11.2617 23.0555C11.4869 23.1829 11.7413 23.2499 12 23.25C12.5918 23.25 13.098 22.905 13.3425 22.407C15.318 22.1583 17.1814 21.3509 18.7139 20.0797C20.2464 18.8086 21.385 17.1265 21.9945 15.231ZM22.407 10.6575C22.1583 8.68192 21.3508 6.81837 20.0795 5.28587C18.8082 3.75337 17.1259 2.61559 15.2302 2.00625L14.7698 3.43425C16.3796 3.95176 17.8103 4.914 18.8967 6.2099C19.983 7.5058 20.6807 9.0825 20.9093 10.758C20.6949 10.903 20.5218 11.1011 20.4067 11.3328C20.2915 11.5646 20.2383 11.8222 20.2522 12.0806C20.266 12.339 20.3465 12.5894 20.4858 12.8075C20.625 13.0256 20.8183 13.204 21.0469 13.3253C21.2755 13.4466 21.5316 13.5066 21.7903 13.4997C22.049 13.4927 22.3015 13.419 22.5232 13.2856C22.745 13.1522 22.9284 12.9637 23.0558 12.7384C23.1831 12.5132 23.25 12.2588 23.25 12C23.2497 11.7198 23.1705 11.4453 23.0216 11.2079C22.8726 10.9705 22.6599 10.7798 22.4078 10.6575M12 0.75C11.4082 0.75 10.902 1.095 10.6575 1.593C8.68204 1.84174 6.8186 2.64911 5.28613 3.92026C3.75365 5.19142 2.61579 6.87354 2.00625 8.769L3.43425 9.231C3.95164 7.62099 4.91383 6.19013 6.20974 5.10364C7.50565 4.01715 9.08241 3.31933 10.758 3.09075C10.903 3.30506 11.1011 3.4782 11.3328 3.59334C11.5646 3.70848 11.8222 3.76171 12.0806 3.74785C12.339 3.73399 12.5894 3.65351 12.8075 3.51425C13.0256 3.37498 13.204 3.18165 13.3253 2.95306C13.4466 2.72447 13.5066 2.46839 13.4997 2.2097C13.4927 1.95102 13.419 1.69853 13.2856 1.47679C13.1522 1.25504 12.9637 1.07157 12.7384 0.944221C12.5132 0.816868 12.2588 0.74996 12 0.75Z"
              fill="#667185"
            />
          </svg>

          <div>
            NDCs-S{" "}
            <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L6 6L11 1"
                stroke="#D0D5DD"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* <div className="menu_item__dropdown">
            <div>Account</div>
            <div>Password</div>
            <div>Account manager</div>
          </div> */}
        </div>
        {/* } */}

        {/* {(hasPermission("superAdmin"||"admin"))&&  */}
        {/* <div
          className={
            pathname.includes("energy-sharing")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() => {
            navigate("/admin/energy-sharing");
            window.scrollTo(0, 0);
          }}
        >
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 18.5C8.69 18.5 6 15.81 6 12.5C6 11.49 6.25 10.53 6.7 9.7L5.24 8.24C4.42975 9.51309 3.99958 10.9909 4 12.5C4 16.92 7.58 20.5 12 20.5V23.5L16 19.5L12 15.5V18.5ZM12 4.5V1.5L8 5.5L12 9.5V6.5C15.31 6.5 18 9.19 18 12.5C18 13.51 17.75 14.47 17.3 15.3L18.76 16.76C19.5702 15.4869 20.0004 14.0091 20 12.5C20 8.08 16.42 4.5 12 4.5Z" fill="#667185" />
          </svg>


          <div>Energy sharing</div>

        </div> */}
        {/* } */}
        {/* {(hasPermission("superAdmin"))&&  */}
        <Menu
          id="basic-menu"
          anchorEl={anchorElThree}
          open={openerThree}
          onClose={handleCloseThree}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            sx={{
              width: "18.4rem",
              fontSize: "1.4rem",
              fontFamily: "Inter",
              fontWeight: "500",
              backgroundColor: "#fff !important",

                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/ndc-requests");
                window.scrollTo(0, 0);
                handleCloseThree();
              }}
            >
              Request
            </MenuItem>
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",

                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/ndc-list");
                window.scrollTo(0, 0);
                handleCloseThree();
              }}
            >
              NDCs-S Table
            </MenuItem>
          </Menu>
          {/* } */}

        {/* {(hasPermission("superAdmin") || hasPermission("admin")) &&  */}
        <div
          className={
            pathname.includes("history") ? "menu_item menu_active" : "menu_item"
          }
          onClick={() => {
            navigate("/admin/history");
            window.scrollTo(0, 0);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 17.125V6.87495L12 1.69995L21 6.87495V12.275C20.7 12.0583 20.3833 11.871 20.05 11.713C19.7167 11.555 19.3667 11.4173 19 11.3V9.09995L15.4 11.175C14.4667 11.4083 13.6207 11.8043 12.862 12.363C12.1033 12.9216 11.4827 13.6006 11 14.4V12.575L5 9.09995V15.95L10.05 18.875C10.1167 19.4083 10.2417 19.9209 10.425 20.413C10.6083 20.905 10.8417 21.3673 11.125 21.7999C11.0917 21.7833 11.0707 21.7706 11.062 21.7619C11.0533 21.7533 11.0327 21.7413 11 21.726L3 17.125ZM12 3.99995L6.075 7.42495L12 10.85L17.925 7.42495L12 3.99995ZM17 23C15.6167 23 14.4373 22.5123 13.462 21.537C12.4867 20.5616 11.9993 19.3826 12 18C12 16.6166 12.4877 15.4373 13.463 14.462C14.4383 13.4866 15.6173 12.9993 17 13C18.3833 13 19.5627 13.4876 20.538 14.463C21.5133 15.4383 22.0007 16.6173 22 18C22 19.3833 21.5123 20.5626 20.537 21.538C19.5617 22.5133 18.3827 23.0006 17 23ZM17.5 17.7999V15H16.5V18.2L18.65 20.35L19.35 19.65L17.5 17.7999Z"
              fill="#667185"
            />
          </svg>

          <div>History</div>

        </div>

        {/* Advert */}

            <div
          className={
            pathname.includes("ads") ? "menu_item menu_active" : "menu_item"
          }
          onClick={() => {
            navigate("/ads");
            window.scrollTo(0, 0);
          }}
        >
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 5V19H5V5H19ZM21 3H3V21H21V3ZM17 17H7V16H17V17ZM17 15H7V14H17V15ZM17 12H7V7H17V12Z" fill="white"/>
</svg>



          <div>Advert section</div>

        </div>

        {/* } */}
         {/* {(hasPermission("superAdmin") || hasPermission("admin")|| hasPermission("RO")|| hasPermission("validator")) && */}
          <div
          className={
            pathname.includes("settings") ? "menu_item active_iot" : "menu_item"
          }
          // onClick={() => {
          //   navigate("/admin/website/settings");
          //   window.scrollTo(0, 0);
          // }}
          onClick={handleClick}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2955 9.01453C11.68 8.95374 11.0607 9.08469 10.5225 9.38945C9.98426 9.69421 9.55339 10.1579 9.28886 10.717C9.02434 11.2761 8.93909 11.9033 9.04479 12.5127C9.1505 13.1221 9.44198 13.684 9.87934 14.1213C10.3167 14.5587 10.8786 14.8502 11.488 14.9559C12.0974 15.0616 12.7246 14.9763 13.2837 14.7118C13.8428 14.4473 14.3065 14.0164 14.6112 13.4782C14.916 12.94 15.0469 12.3207 14.9861 11.7052C14.9168 11.0151 14.6111 10.3703 14.1207 9.87995C13.6304 9.38958 12.9855 9.08384 12.2955 9.01453ZM19.5189 12C19.517 12.3261 19.4931 12.6517 19.4472 12.9745L21.5664 14.6367C21.6587 14.7132 21.7209 14.8199 21.7419 14.9379C21.763 15.056 21.7415 15.1776 21.6813 15.2812L19.6764 18.75C19.6156 18.8527 19.5204 18.9305 19.4077 18.9699C19.295 19.0093 19.1721 19.0076 19.0605 18.9652L16.9558 18.1177C16.8398 18.0714 16.714 18.0547 16.5899 18.0691C16.4658 18.0834 16.3472 18.1283 16.2447 18.1997C15.9235 18.4209 15.586 18.6174 15.235 18.7875C15.1247 18.8411 15.0293 18.9211 14.9572 19.0203C14.8851 19.1196 14.8385 19.2351 14.8216 19.3566L14.5061 21.6014C14.4854 21.72 14.4242 21.8276 14.3329 21.906C14.2415 21.9844 14.1258 22.0287 14.0055 22.0312H9.99582C9.87748 22.0292 9.76337 21.9869 9.67228 21.9113C9.5812 21.8357 9.51857 21.7314 9.49473 21.6155L9.17973 19.3739C9.16204 19.2511 9.11427 19.1345 9.04067 19.0346C8.96707 18.9346 8.86992 18.8544 8.75785 18.8011C8.40733 18.6319 8.07094 18.4349 7.75192 18.2119C7.64977 18.1408 7.53155 18.0963 7.40791 18.0823C7.28426 18.0683 7.15908 18.0853 7.04364 18.1317L4.93942 18.9788C4.82791 19.0212 4.70499 19.023 4.59231 18.9837C4.47964 18.9444 4.38444 18.8666 4.32348 18.7641L2.31864 15.2953C2.25836 15.1917 2.23682 15.07 2.25785 14.952C2.27888 14.834 2.34112 14.7272 2.43348 14.6508L4.22457 13.2445C4.3227 13.1666 4.39982 13.0655 4.44893 12.9502C4.49805 12.835 4.5176 12.7093 4.50582 12.5845C4.48895 12.3891 4.47864 12.1941 4.47864 11.9986C4.47864 11.8031 4.48848 11.6109 4.50582 11.4197C4.51632 11.2957 4.4958 11.1711 4.44613 11.057C4.39646 10.9429 4.3192 10.843 4.22129 10.7662L2.43114 9.36C2.34027
          9.28317 2.27935 9.17681 2.25904 9.05957C2.23872 8.94232 2.26032 8.82167 2.32004 8.71875L4.32489 5.25C4.38577 5.14734 4.48094 5.06946 4.59362 5.0301C4.7063 4.99074 4.82926 4.99242 4.94082 5.03484L7.04551 5.88234C7.16157 5.92856 7.28729 5.94525 7.41139 5.93094C7.5355 5.91662 7.65411 5.87174 7.7566 5.80031C8.07782 5.57912 8.41535 5.38262 8.76629 5.2125C8.87662 5.15887 8.97206 5.07891 9.04416 4.97966C9.11627 4.88042 9.16283 4.76494 9.17973 4.64344L9.4952 2.39859C9.51592 2.28004 9.57717 2.17236 9.66848 2.09396C9.75979 2.01555 9.8755 1.9713 9.99582 1.96875H14.0055C14.1238 1.9708 14.238 2.01309 14.329 2.08867C14.4201 2.16425 14.4828 2.2686 14.5066 2.38453L14.8216 4.62609C14.8393 4.74894 14.8871 4.86551 14.9607 4.96544C15.0343 5.06537 15.1314 5.14557 15.2435 5.19891C15.594 5.3681 15.9304 5.56514 16.2494 5.78813C16.3516 5.85919 16.4698 5.90373 16.5934 5.91772C16.7171 5.93172 16.8423 5.91473 16.9577 5.86828L19.0619 5.02125C19.1734 4.97879 19.2963 4.97704 19.409 5.01631C19.5217 5.05558 19.6169 5.13336 19.6779 5.23594L21.6827 8.70469C21.743 8.80832 21.7645 8.92999 21.7435 9.04802C21.7225 9.16604 21.6602 9.27278 21.5679 9.34922L19.7768 10.7555C19.6782 10.8331 19.6006 10.9342 19.5511 11.0494C19.5016 11.1647 19.4817 11.2905 19.4932 11.4155C19.5086 11.6095 19.5189 11.8045 19.5189 12Z"
              fill="#667185"
            />
          </svg>
 
          <div>
            Settings{" "}
            <svg
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L6 6L11 1"
                stroke="#D0D5DD"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
 
          {/* <div className="menu_item__dropdown">
            <div>Account</div>
            <div>Password</div>
            <div>Account manager</div>
          </div> */}
        </div>
        {/* } */}
        
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={opener}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",
 
                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/account-settings");
                window.scrollTo(0, 0);
                handleClose();
              }}
            >
              Account
            </MenuItem>
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                backgroundColor: "#fff !important",
 
                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/password-settings");
                window.scrollTo(0, 0);
                handleClose();
              }}
            >
              Password
            </MenuItem>
            <MenuItem
              sx={{
                width: "18.4rem",
                fontSize: "1.4rem",
                fontFamily: "Inter",
                fontWeight: "500",
                "&:hover": {
                  color: "#063",
                  backgroundColor: "#fff",
                },
              }}
              className="subMenu"
              onClick={() => {
                navigate("/admin/account-management-settings");
                window.scrollTo(0, 0);
                handleClose();
              }}
            >
              Account Manager
            </MenuItem>
          </Menu>
      </div>

      <div className="logout pointer" onClick={handleLogout}>
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 4L13.59 5.41L16.17 8H6V10H16.17L13.59 12.58L15 14L20 9L15 4ZM2 2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H10V16H2V2Z"
            fill="#667185"
          />
        </svg>

        <div>Log out</div>
      </div>
    </div>
  );
};


export default SideBar;
